exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-fields-list[data-v-5ee1963e]{list-style-type:none;padding-left:0}.custom-field[data-v-5ee1963e]{display:grid;grid-template-columns:1fr 1fr;margin-bottom:10px}", ""]);

// exports
